import { render, staticRenderFns } from "./SessionsTable.vue?vue&type=template&id=6bc54768&"
import script from "./SessionsTable.vue?vue&type=script&lang=js&"
export * from "./SessionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/musili/musilidev/webroot/work-bmm/01_DEX/dex/front-end/web-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bc54768')) {
      api.createRecord('6bc54768', component.options)
    } else {
      api.reload('6bc54768', component.options)
    }
    module.hot.accept("./SessionsTable.vue?vue&type=template&id=6bc54768&", function () {
      api.rerender('6bc54768', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenant/views/Dashboard/Components/SessionsTable.vue"
export default component.exports